<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col><h3>■契約書の送付先</h3></v-col>
                    </v-row>
                </v-container>
                <v-container v-if="isPaid">
                    <v-row>
                        <v-col class="py-0">
                            <badge-component tile :content="badgeContent">
                               <div class="pt-1"> 【承認者】</div>
                            </badge-component>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <div id="address-sticky-table" style="width: 100%;">
                                <v-data-table :headers="authorizerHeaders" :items="authorizerItems" hide-default-footer fixed-header>
                                    <template v-slot:body="props">
                                      <draggable :list="authorizerItems" tag="tbody" >
                                        <tr v-for="(item, index) in authorizerItems" :key="index" >
                                          <td class="td_move">
                                            <v-icon small class="page__grab-icon" >mdi-arrow-all</v-icon>
                                          </td>
                                          <td class="td_order">
                                            <v-avatar :size="30" color="grey lighten-4">
                                                <span>{{ index + 1 }}</span>
                                            </v-avatar>
                                          </td>
                                          <td class="td_name"> {{ item.destination_user_name }} </td>
                                          <td class="td_email"> {{ item.destination_email_address }} </td>
                                          <td class="td_company"> {{  }} </td>
                                          <td class="td_access_code"> 
                                              <v-icon v-if="item.access_code">mdi-lock</v-icon>
                                          </td>
                                          <td class="td_actionBtn">
                                            <v-btn color="blue" class="white--text" @click="editAuthorizerItem(item)">編集</v-btn>
                                          </td>
                                          <td class="td_actionBtn">
                                            <v-btn color="blue-grey" class="white--text" @click="confirmAuthorizerDialog(item)">削除</v-btn>
                                          </td>
                                        </tr>
                                      </draggable>
                                    </template>
                                    <template v-slot:footer>
                                        <div class="pt-2">
                                            <v-btn @click="addAuthorizerItem" color="orange" class="white--text">承認者を追加</v-btn>
                                        </div>
                                    </template>
                                  </v-data-table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container>
                    <v-row v-if="isPaid">
                        <v-col class="py-0">
                            <badge-component tile content="必　須">
                                <div class="pt-1">【署名者】</div>
                            </badge-component>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <div id="address-sticky-table" style="width: 100%;">
                                <v-data-table :headers="headers" :items="signerItems" hide-default-footer fixed-header>
                                    <template v-slot:body="props">
                                      <draggable :list="signerItems" tag="tbody" >
                                        <tr v-for="(item, index) in signerItems" :key="index" >
                                          <td class="td_move">
                                            <v-icon small class="page__grab-icon">mdi-arrow-all</v-icon>
                                          </td>
                                          <td class="td_order">
                                            <v-avatar :size="30" color="grey lighten-4">
                                                <span>{{ authorizerCount + index + 1 }}</span>
                                            </v-avatar>
                                          </td>
                                          <td class="td_name">
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">{{ item.destination_user_name }}</span>
                                              </template>
                                              <span>{{ item.destination_user_name }}</span>
                                            </v-tooltip>
                                          </td>
                                          <td class="td_email"> {{ item.destination_email_address }} </td>
                                          <td class="td_company"> {{ item.destination_company_name }} </td>
                                          <td class="td_access_code"> 
                                              <v-icon v-if="item.access_code">mdi-lock</v-icon>
                                          </td>
                                          <td class="td_actionBtn">
                                            <v-btn color="blue" class="white--text" @click="editItem(item)">編集</v-btn>
                                          </td>
                                          <td class="td_actionBtn">
                                            <v-btn color="blue-grey" class="white--text" @click="confirmDialog(item)">削除</v-btn>
                                          </td>
                                        </tr>
                                      </draggable>
                                    </template>
                                    <template v-slot:footer>
                                        <v-row class="pt-2">
                                            <v-col>
                                                <v-btn @click="addItem" color="orange" class="white--text">署名者を追加</v-btn>
                                            </v-col>
                                            <v-col align="right">
                                                <input id="fileUpload" type="file" @change="inportCsv"  accept=".csv" hidden>
                                                <v-btn @click="chooseFiles" color="orange" class="white--text">宛先のインポート(CSV)</v-btn>
                                            </v-col>
                                        </v-row>
                                    </template>
                                  </v-data-table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container>
                    <v-row>
                        <v-col>
                            <h3>■契約書の転送</h3>
                            <v-radio-group v-model="model.can_transfer" row>
                                <v-radio label="許可しない" :value="0"></v-radio>
                                <v-radio label="許可する" :value="1"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <!--<v-row>-->
                    <!--    <v-col>-->
                    <!--        <h3>■二要素認証</h3>-->
                    <!--        <v-radio-group v-model="model.is_two_factor_authentication" row >-->
                    <!--            <v-radio label="なし" :value="0"></v-radio>-->
                    <!--            <v-radio label="有効にする" :value="1"></v-radio>-->
                    <!--        </v-radio-group>-->
                    <!--    </v-col>-->
                    <!--</v-row>-->
                </v-container>
            </v-card-text>
        </v-card>
        <div class="text-center pt-2">
            <v-btn color="red" class="white--text" :disabled="!isValid" @click="next">次へ</v-btn>
        </div>
        
        <!-- 承認者ダイアログ -->
        <authorizer-dialog-component v-if="authorizerDialog" :authorizerDialog.sync="authorizerDialog"
            :sender="senderItem" :currentAuthorizerList="authorizerItems" :currentIndex="currentIndex" :currentItem="currentItem" @clickOk="changeAuthorizerEvent">
            <template v-slot:ok-btn>OK</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </authorizer-dialog-component>
        
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="confirmAuthorizerDeleteDialog" :dialog.sync="confirmAuthorizerDeleteDialog" :currentIndex="currentIndex" :currentItem="currentItem" @clickOk="deleteAuthorizerItem(currentItem)" okBtn="削除" cancelbtn="キャンセル">
            <div>{{ currentItem.destination_user_name }}を削除しますか？</div>
        </simple-dialog-component>
        
        <!-- 署名者ダイアログ -->
        <signer-dialog-component v-if="signerDialog" :signerDialog.sync="signerDialog"
            :sender="senderItem" :currentSignerList="signerItems" :currentIndex="currentIndex" :currentItem="currentItem" @clickOk="changeEvent">
            <template v-slot:ok-btn>OK</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </signer-dialog-component>
        
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="confirmDeleteDialog" :dialog.sync="confirmDeleteDialog" :currentIndex="currentIndex" :currentItem="currentItem" @clickOk="deleteItem(currentItem)" okBtn="削除" cancelbtn="キャンセル">
            <div>{{ currentItem.destination_user_name }}を削除しますか？</div>
        </simple-dialog-component>
    </div>
</template>

<script>
    import { required, max } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    import draggable from 'vuedraggable'
    
    extend('required', {...required, message: '入力必須項目です',});
    extend('max', {
        ...max,
        message: '{length} 文字以内でご入力ください',
    });
    
    export default {
        components:{
            ValidationProvider,  // 入力時にリアルタイムでエラーチェック
            ValidationObserver,  // 送信時にエラーチェック
            draggable,           // ドラッグ＆ドロップ
        },
        props: {
            model: Object,
            sender: Object,
            authorizer: Array,
            signer: Array,
            isPaid: Boolean,
            needsApproval: Number,
        },
        data() {
            return {
                senderItem:[],
                authorizerItems: [],
                signerItems: [],
                // items: [],
                authorizerDialog: false,
                signerDialog: false,
                confirmDeleteDialog: false,
                confirmAuthorizerDeleteDialog: false,
                authorizerHeaders: [
                    { text: '', value: 'icon', sortable: false, width: '35' },
                    { text: '送付順', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'destination_user_name', sortable: false },
                    { text: 'メールアドレス', value: 'destination_email_address', sortable: false },
                    { text: '', value: 'destination_company_name', sortable: false },
                    { text: '', value: 'has_access_code', sortable: false, width: '50' },
                    { text: '', value: 'edit', sortable: false, width: '75' },
                    { text: '', value: 'delete', sortable: false, width: '75' },
                ],
                headers: [
                    { text: '', value: 'icon', sortable: false, width: '35' },
                    { text: '送付順', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'destination_user_name', sortable: false },
                    { text: 'メールアドレス', value: 'destination_email_address', sortable: false },
                    { text: '会社名', value: 'destination_company_name', sortable: false },
                    { text: '', value: 'has_access_code', sortable: false, width: '50' },
                    { text: '', value: 'edit', sortable: false, width: '75' },
                    { text: '', value: 'delete', sortable: false, width: '75' },
                ],
                sending: false,
                message: {
                    success: false,
                    text: '',
                },
                inportCsvData:[],
            };
        },
        computed: {
            authorizerCount: {
                get() {
                    return this.authorizerItems.length;
                },
                set() {}
            },
            badgeContent() {
                return this.needsApproval == 1 ? '必　須' : '任　意';
            },
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            isValid: {
                get() {
                    if(this.needsApproval == 1 && !this.authorizerItems.length) {
                        return false;
                    }
                    // テンプレートには氏名・メールアドレスが空の送付先が存在するため、次へボタンを制御
                    if (this.signerItems.length > 0){
                        for(let i = 0; i < this.signerItems.length; i++) {
                            if (!(this.signerItems[i].destination_email_address.length > 0) || !(this.signerItems[i].destination_user_name.length > 0)) {
                                return false;
                            }
                        }
                    } else {
                        return false;
                    }
                    for(let i = 0; i < this.authorizerItems.length; i++) {
                        if (!(this.authorizerItems[i].destination_email_address.length > 0) || !(this.authorizerItems[i].destination_user_name.length > 0)) {
                            return false;
                        }
                    }
                    return true;
                },
                set(value) {
                    
                }
            }
        },
        // 初期表示のデータ
        created : function() {
            this.senderItem = this.sender;
            this.signerItems = this.signer;
            this.authorizerItems = this.authorizer;
        },
        methods: {
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.save();
                    if (result) {
                        window.location = "input";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 保存
            save: async function(draft = null) {
                var self = this;
                let result = false;
                await window.axios
                    .post('address', {
                        'signer': this.signerItems,
                        'authorizer': this.authorizerItems,
                        'can_transfer': this.model.can_transfer,
                        'draft': draft,
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            result = true;
                            self.senderItem = response.data.sender;
                            self.signerItems = response.data.signer;
                            self.authorizerItems = response.data.authorizer;
                        } 
                        else {
                            result = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "保存処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        result = false;
                        console.log(response);
                        self.message.text = "保存処理に失敗しました";
                        self.message.success = false;
                    }
                );
                return result;
            },
            addAuthorizerItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    // id: '',
                    destination_user_name: '',
                    destination_email_address: '',
                    destination_company_name: '',
                    access_code: '',
                };
                this.authorizerDialog = true;
            },
            editAuthorizerItem: function(item) {
                this.currentIndex = this.authorizerItems.indexOf(item);
                this.currentItem = JSON.parse(JSON.stringify(item));    // クローンの意図
                this.authorizerDialog = true;
            },
            addItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    // id: '',
                    destination_user_name: '',
                    destination_email_address: '',
                    destination_company_name: '',
                    access_code: '',
                };
                this.signerDialog = true;
            },
            editItem: function(item) {
                this.currentIndex = this.signerItems.indexOf(item);
                this.currentItem = JSON.parse(JSON.stringify(item));    // クローンの意図
                this.signerDialog = true;
            },
            changeAuthorizerEvent: function(value) {
                if (this.currentIndex === null) {
                    this.authorizerItems.push(value);
                } else {
                    this.$set(this.authorizerItems, this.currentIndex, value);
                }
                this.currentItem = value;
            },
            changeEvent: function(value) {
                if (this.currentIndex === null) {
                    this.signerItems.push(value);
                } else {
                    this.$set(this.signerItems, this.currentIndex, value);
                }
                this.currentItem = value;
            },
            confirmAuthorizerDialog: function(item) {
                this.currentIndex = this.authorizerItems.indexOf(item);
                this.currentItem = item;
                this.confirmAuthorizerDeleteDialog = true;
            },
            confirmDialog: function(item) {
                this.currentIndex = this.signerItems.indexOf(item);
                this.currentItem = item;
                this.confirmDeleteDialog = true;
            },
            deleteAuthorizerItem: function(item) {
                const index = this.authorizerItems.indexOf(item);
                this.authorizerItems.splice(index, 1);
            },
            deleteItem: function(item) {
                const index = this.signerItems.indexOf(item);
                this.signerItems.splice(index, 1);
            },
            // 宛先のインポート(CSV)ファイル選択
            chooseFiles: function() {
                document.getElementById("fileUpload").click();
            },
            // CSVファイル読み込む
            inportCsv:function(e) {
                var self = this;
                let file = e.target.files[0] || e.dataTransfer.files[0];
                var header = ['access_code','destination_user_name','destination_email_address','destination_company_name'];
                let reader = new FileReader();
                reader.readAsText (file, 'utf-8');
                reader.onload = () => {
                    let arr = reader.result.split('\n');
                    let arrHeader = arr[0].split(',').map(item => item.trim());
                    if(JSON.stringify(arrHeader) != JSON.stringify(header)){
                        self.message.text = "正しい宛先CSVファイルを選択してください";
                        return;
                    }
                    let csvResult = arr.map(item => {
                          let _str = {};
                          item.split(',').forEach((v, i) => {
                              _str[arrHeader[i]] = v.trim();
                          });
                          return _str;
                    });
                    csvResult.shift()
                    csvResult.pop()
                    this.inportCsvData = csvResult
                    // 画面表示追加
                    if(this.inportCsvData.length > 0){
                        this.inportCsvData.forEach(element => this.signerItems.push(element));
                    }
                };
                // リセット
                document.getElementById("fileUpload").value = "";
            }
            
        },
    };
</script>

<style scoped>
    /* table */
    ::v-deep th {
        padding: 5px 0!important;
        word-break: keep-all;
        white-space : nowrap;
    }
    ::v-deep td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0!important;
    }
    .td_move {
        width: 35px;
        text-align: center;
    }
    .td_order {
        width: 69px;
        text-align: center;
    }
    .td_name {
        width: 200px;
        max-width:400px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .td_email {
        /*width: 250px;*/
        padding-right: 15px !important;
    }
    .td_company {
        
    } 
    .td_access_code {
        width: 50px;
        text-align: center;
    }
    .td_actionBtn {
        width: 75px;
        text-align: center;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>

<style>
    #address-sticky-table > div > div > table > tbody > tr:hover > td
    {
        background:#EEE !important;
    }

    /* datatableの列を固定化する(1列目) */
    #address-sticky-table > div > div > table > tbody > tr > td:nth-child(1),
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(1)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0px;
        z-index: 97;
        background:white;
    }
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(1)
    {
        z-index: 98;
    }
     
    /* datatableの列を固定化する(2列目) */
    /* 1列目の幅の分だけ、leftの値を増やして固定化する */
    #address-sticky-table > div > div > table > tbody > tr > td:nth-child(2),
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(2)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 35px;
        z-index: 97;
        background:white;
    }

    #address-sticky-table > div > div > table > thead > tr > th:nth-child(2)
    {
        z-index: 98;
    }
    
    /* datatableの列を固定化する(3列目) */
    /* 1,2列目の幅の分だけ、leftの値を増やして固定化する */
    #address-sticky-table > div > div > table > tbody > tr > td:nth-child(3),
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(3)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 100px;
        z-index: 97;
        background:white;
    }
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(3)
    {
        z-index: 98;
    }
    
    /* datatableの列を固定化する(7列目) */
    /* 8列目の幅の分だけ、rightの値を増やして固定化する */
    #address-sticky-table > div > div > table > tbody > tr > td:nth-child(7),
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(7)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 75px;
        z-index: 97;
        background:white;
    }
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(7)
    {
        z-index: 98;
    }
    
    /* datatableの列を固定化する(8列目) */
    #address-sticky-table > div > div > table > tbody > tr > td:nth-child(8),
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(8)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0px;
        z-index: 97;
        background:white;
    }
    #address-sticky-table > div > div > table > thead > tr > th:nth-child(8)
    {
        z-index: 98;
    }
</style>